import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {loc} from "core/common/config/locales";


const gridLocation = 'entityList';

@observer
export default class EntityList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Entities`;
  static icon = 'book';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("EntityList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
    });
  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/metamodel/entityList.tsx